import Dreams from "source/app/presentation/MainPanel/Dreams/Dreams";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { EDA } from "motw_core/Dreams/EDreamAttribute";
import { IsFilteringForDreamAttribute } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Filters/Helpers/IsFilteringForDreamAttribute";

export function ActiveDreamFilterClass(dreams: Dreams, attribute: EDA) {
    const isFilterActive = IsFilteringForDreamAttribute(
        dreams.state,
        attribute
    );

    const className = isFilterActive ? activeDreamFilterStyle : ``;
    return { className };
}

export const activeDreamFilterStyle = StyleClass(`activeDreamFilterStyle`, {
    background: "rgb(0 0 0 / 20%)",
    padding: "5px 0px",
    borderRadius: "5px",
});
